import { BrandThemesEnum, ImageRatioEnum, PositionEnum, SizesEnum, ThemesEnum } from '@seb/web-design-system/core';
import { ArgumentsLayoutEnum } from '@seb/web-design-system/arguments';

import { WcConfig } from '../../models/wc-config.model';

export const wcMoulinexConfig: WcConfig = {
  isRecipesEnabled: true,
  warranty: '/warranty-&-repair',
  isThemeDark: false,
  isArgumentUnderlined: false,
  sliderCategoryOnly: true,
  isTeaserEmbedded: true,
  linkCardSubcategories: true,
  iconPos: PositionEnum.left,
  recipeDetailsPage: {
    reviews: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: BrandThemesEnum.brand
    }
  },
  categoryPage: {
    lame1: {
      textConfig: PositionEnum.left,
      mediaConfig: PositionEnum.right,
      theme: BrandThemesEnum.brand,
      backgroundTheme: ThemesEnum.default
    },
    lame4: {
      backgroundTheme: ThemesEnum.default
    },
    lame7: {
      textConfig: PositionEnum.center,
      mediaConfig: PositionEnum.left,
      theme: ThemesEnum.light,
      layout: ArgumentsLayoutEnum.default
    },
    faq: {
      backgroundTheme: ThemesEnum.default
    }
  },
  subCategoryPage: {
    lame1: {
      textConfig: PositionEnum.left,
      mediaConfig: PositionEnum.right,
      theme: BrandThemesEnum.brand,
      layout: ArgumentsLayoutEnum.default,
      backgroundTheme: ThemesEnum.default
    },
    lame4: {
      titleTextConfig: PositionEnum.center,
      titleTheme: BrandThemesEnum.brand,
      pushSize: SizesEnum.s,
      pushImageRatio: ImageRatioEnum.r16_9,
      pushTextConfig: PositionEnum.center,
      pushMediaConfig: PositionEnum.top,
      pushTheme: ThemesEnum.light,
      backgroundTheme: ThemesEnum.default
    },
    lame5: {
      titleTheme: BrandThemesEnum.brand,
      titleTextConfig: PositionEnum.center,
      backgroundTheme: ThemesEnum.default
    },
    lame7: {
      textConfig: PositionEnum.center,
      mediaConfig: PositionEnum.left,
      theme: ThemesEnum.promo2,
      // argumentsLayout: ThemesEnum.promo,
      // hasGradient: ThemesEnum.promo,
      backgroundTheme: ThemesEnum.default
    },
    lame8: {
      textConfig: PositionEnum.left,
      theme: ThemesEnum.light,
      mediaConfig: PositionEnum.left,
      layout: ArgumentsLayoutEnum.default,
      hasGradient: false
    },
    lame9: {
      titleTextConfig: PositionEnum.center,
      titleTheme: BrandThemesEnum.brand,
      backgroundTheme: ThemesEnum.default
    },
    lame10: {
      textConfig: PositionEnum.center,
      theme: ThemesEnum.light,
      mediaConfig: PositionEnum.left,
      layout: ArgumentsLayoutEnum.default
    },
    lame11: {
      titleTextConfig: PositionEnum.center,
      titleTheme: BrandThemesEnum.brand,
      backgroundTheme: ThemesEnum.default
    }
  },
  accessoryPage: {
    categories: {
      titleTheme: BrandThemesEnum.brand,
      backgroundTheme: ThemesEnum.default
    },
    search: {
      titleTheme: ThemesEnum.dark,
      backgroundTheme: ThemesEnum.default
    }
  },
  pdp: {
    bundlesOrProducts: {
      backgroundTheme: ThemesEnum.white,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: false
    },
    designedFor: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: false
    },
    productInfoArguments: {
      theme: ThemesEnum.promo,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: false
    },
    benefits: {
      backgroundTheme: ThemesEnum.default,
      titleUnderlined: false,
      titleTheme: BrandThemesEnum.brand
    },
    range: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: false
    },
    recipes: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: false
    },
    comparator: {
      backgroundTheme: ThemesEnum.white,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: false
    },
    freeEditoBUArguments: {
      theme: ThemesEnum.light,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: false
    },
    freeEditoLocalArguments: {
      theme: ThemesEnum.light,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: false
    },
    howTo: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: false,
      pushTheme: ThemesEnum.light,
      pushTitleTheme: ThemesEnum.dark
    },
    accessories: {
      backgroundTheme: ThemesEnum.white,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: false
    },
    replacementParts: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: false
    },
    ifu: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: false
    },
    faqs: {
      backgroundTheme: ThemesEnum.white,
      titleTheme: BrandThemesEnum.brand,
      titleUnderlined: false
    },
    disclaimer: {
      backgroundTheme: ThemesEnum.default
    }
  }
};
